var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mvms
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%", "padding-top": "15px" },
              attrs: { data: _vm.mvms.rows },
            },
            [
              _c("el-table-column", {
                attrs: { label: "機台編號" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.AssetNo) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  992003980
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "客戶" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.client.name) + " "),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3576455885
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "放置地點" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.locate.name) + " "),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3561387268
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "巡補員" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.user.name) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  1588679301
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "狀態", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("statusTag", {
                            attrs: {
                              status: scope.row.Status,
                              "updated-at": scope.row.updated_at,
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3802011691
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "最後連線時間" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("lastUpdate", {
                            attrs: { "updated-at": scope.row.updated_at },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2797246848
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }